import React, { useState } from "react";
import { companyInfo } from "../../data/general";

interface PropertyShareButtonsProps {
  title: string;
  url: string;
  className?: string;
}

const PropertyShareButtons: React.FC<PropertyShareButtonsProps> = ({
  title,
  url,
  className = "",
}) => {
  const [copied, setCopied] = useState(false);

  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Copy this link:", url);
    }
  };

  const phoneDigits = companyInfo.phone.replace(/\D/g, "");
  const whatsAppNumber = phoneDigits.startsWith("440")
    ? `44${phoneDigits.slice(3)}`
    : phoneDigits.startsWith("0")
    ? `44${phoneDigits.slice(1)}`
    : phoneDigits;
  const whatsAppHref = `https://wa.me/${whatsAppNumber}?text=${encodeURIComponent(
    `${title}\n${url}`
  )}`;
  const mailtoHref = `mailto:?subject=${encodeURIComponent(
    title
  )}&body=${encodeURIComponent(`I thought you might like this property:\n\n${title}\n${url}`)}`;

  return (
    <div
      className={`inline-flex items-center gap-2 ${className}`}
      onClick={stopPropagation}
      onKeyDown={(e) => e.stopPropagation()}
      role="group"
      aria-label="Share property"
    >
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center justify-center px-3 h-9 rounded-full border border-solid border-[rgba(0,0,0,0.12)] bg-white/90 text-xs font-manrope uppercase tracking-wider hover:border-brand-yellow transition-colors"
        aria-label="Copy property link"
      >
        {copied ? "Copied" : "Copy link"}
      </button>
      <a
        href={whatsAppHref}
        target="_blank"
        rel="noreferrer"
        onClick={stopPropagation}
        className="inline-flex items-center justify-center px-3 h-9 rounded-full border border-solid border-[rgba(0,0,0,0.12)] bg-white/90 text-xs font-manrope uppercase tracking-wider hover:border-brand-yellow transition-colors"
        aria-label="Share on WhatsApp"
      >
        WhatsApp
      </a>
      <a
        href={mailtoHref}
        onClick={stopPropagation}
        className="inline-flex items-center justify-center px-3 h-9 rounded-full border border-solid border-[rgba(0,0,0,0.12)] bg-white/90 text-xs font-manrope uppercase tracking-wider hover:border-brand-yellow transition-colors"
        aria-label="Share by email"
      >
        Email
      </a>
    </div>
  );
};

export default PropertyShareButtons;
